import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './POSTAUCT_Redemption_Period_Review.css';

const POSTAUCT_Redemption_Period_Review = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"POSTAUCT_REDEMPTION_PERIOD_REVIEW",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	POSTAUCT_REDEMPTION_PERIOD_REVIEW:-1
  });


  const [POSTAUCT_REDEMPTION_PERIOD_REVIEW, setPOSTAUCT_REDEMPTION_PERIOD_REVIEW] = React.useState(null);
  const [POSTAUCT_REDEMPTION_PERIOD_REVIEW_D, setPOSTAUCT_REDEMPTION_PERIOD_REVIEW_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Post-Auction Redemption Period Review');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/POSTAUCT_Redemption_Period_Review',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewPOSTAUCT_REDEMPTION_PERIOD_REVIEW(clientInfo,"OpenNew");

		navigate('/POSTAUCT_Redemption_Period_Review',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Redemption_Period_Review_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewPOSTAUCT_REDEMPTION_PERIOD_REVIEW(clientInfo,"OpenNew");
		}
		navigate('/POSTAUCT_Redemption_Period_Review',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Redemption_Period_Review_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Redemption_Period_Review_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Redemption_Period_Review_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
		if(Temp_Data2.status!="New"){
			handleDeletePOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data2);
			navigate('/POSTAUCT_Redemption_Period_Review#New',{replace:true});
		} 
		else 
			navigate('/POSTAUCT_Redemption_Period_Review',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Redemption_Period_Review',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Redemption_Period_Review',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Redemption_Period_Review',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Redemption_Period_Review',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!POSTAUCT_REDEMPTION_PERIOD_REVIEW) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_${i}_SECTION`;
	  const headerId = `#POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [POSTAUCT_REDEMPTION_PERIOD_REVIEW]) ;


  
  
  var Ids = [];
  for(var Ele in POSTAUCT_REDEMPTION_PERIOD_REVIEW){
	  for(var Sec in POSTAUCT_REDEMPTION_PERIOD_REVIEW[Ele]){
		if(Sec == "id")
			Ids.push(POSTAUCT_REDEMPTION_PERIOD_REVIEW[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(POSTAUCT_REDEMPTION_PERIOD_REVIEW[Ele]["status"]);
		else if(Array.isArray(POSTAUCT_REDEMPTION_PERIOD_REVIEW[Ele][Sec]))
			  for(var Row in POSTAUCT_REDEMPTION_PERIOD_REVIEW[Ele][Sec])  // Convert to POSTAUCT_REDEMPTION_PERIOD_REVIEW[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in POSTAUCT_REDEMPTION_PERIOD_REVIEW[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["POSTAUCT_REDEMPTION_PERIOD_REVIEW"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewPOSTAUCT_REDEMPTION_PERIOD_REVIEW(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_REDEMPTION_PERIOD_REVIEW`).then((response1) => {
		if(!POSTAUCT_REDEMPTION_PERIOD_REVIEW) 
			setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_REDEMPTION_PERIOD_REVIEW_D`).then((response2) => {
			setPOSTAUCT_REDEMPTION_PERIOD_REVIEW_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddPOSTAUCT_REDEMPTION_PERIOD_REVIEW_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewPOSTAUCT_REDEMPTION_PERIOD_REVIEW = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_REDEMPTION_PERIOD_REVIEW/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataPOSTAUCT_REDEMPTION_PERIOD_REVIEW = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_REDEMPTION_PERIOD_REVIEW/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutPOSTAUCT_REDEMPTION_PERIOD_REVIEW = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_REDEMPTION_PERIOD_REVIEW/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostPOSTAUCT_REDEMPTION_PERIOD_REVIEW = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_REDEMPTION_PERIOD_REVIEW', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeletePOSTAUCT_REDEMPTION_PERIOD_REVIEW = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_REDEMPTION_PERIOD_REVIEW', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
	Temp_Data["1"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_0"]=value;
	//handleAddPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data,App_Data['POSTAUCT_REDEMPTION_PERIOD_REVIEW']);
	Form_Data_onChange("1","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
    setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
 }; 
  
    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
	Temp_Data["1"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_1"]=value;
	//handleAddPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data,App_Data['POSTAUCT_REDEMPTION_PERIOD_REVIEW']);
	Form_Data_onChange("1","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
    setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
 }; 
  
  
      
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_2_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
	Temp_Data["1"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_2"]=value ? true : false; // optionally just use boolean
	//handleAddPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data,App_Data['POSTAUCT_REDEMPTION_PERIOD_REVIEW']);
	Form_Data_onChange("1","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
    setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
 }; 
  



const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
	Temp_Data["1"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_3"]=value;
	Form_Data_onChange("1","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_3",value,Temp_Data);
 	//handleLastDataPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
    setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
	//handleAddPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data,App_Data['POSTAUCT_REDEMPTION_PERIOD_REVIEW']);
  }; 
  

    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
	Temp_Data["2"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_0"]=value;
	Form_Data_onChange("2","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_0",value,Temp_Data);
    setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
  }; 
  
    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
	Temp_Data["2"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_1"]=value;
	Form_Data_onChange("2","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_1",value,Temp_Data);
    setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
  }; 
  
    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
	Temp_Data["2"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_2"]=value;
	//handleAddPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data,App_Data['POSTAUCT_REDEMPTION_PERIOD_REVIEW']);
	Form_Data_onChange("2","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
    setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
 }; 
  

const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
	Temp_Data["3"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_3_0"]=value;
	Form_Data_onChange("3","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_3_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
    setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
	//handleAddPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data,App_Data['POSTAUCT_REDEMPTION_PERIOD_REVIEW']);
  }; 
  

  
      
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_3_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
	Temp_Data["3"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_3_1"]=value ? true : false; // optionally just use boolean
	//handleAddPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data,App_Data['POSTAUCT_REDEMPTION_PERIOD_REVIEW']);
	Form_Data_onChange("3","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_3_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
    setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
 }; 
  


    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
	Temp_Data["4"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_4_0"]=value;
	//handleAddPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data,App_Data['POSTAUCT_REDEMPTION_PERIOD_REVIEW']);
	Form_Data_onChange("4","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_4_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
    setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
 }; 
  

const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
	Temp_Data["4"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_4_1"]=value;
	Form_Data_onChange("4","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_4_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
    setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
	//handleAddPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data,App_Data['POSTAUCT_REDEMPTION_PERIOD_REVIEW']);
  }; 
  

    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
	Temp_Data["5"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_0"]=value;
	//handleAddPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data,App_Data['POSTAUCT_REDEMPTION_PERIOD_REVIEW']);
	Form_Data_onChange("5","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
    setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
 }; 
  
    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
	Temp_Data["5"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_1"]=value;
	//handleAddPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data,App_Data['POSTAUCT_REDEMPTION_PERIOD_REVIEW']);
	Form_Data_onChange("5","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
    setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
 }; 
  
    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
	Temp_Data["5"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_2"]=value;
	//handleAddPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data,App_Data['POSTAUCT_REDEMPTION_PERIOD_REVIEW']);
	Form_Data_onChange("5","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
    setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
 }; 
  
    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
	Temp_Data["5"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_3"]=value;
	//handleAddPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data,App_Data['POSTAUCT_REDEMPTION_PERIOD_REVIEW']);
	Form_Data_onChange("5","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_3",value,Temp_Data);
 	//handleLastDataPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
    setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
 }; 
  

const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
	Temp_Data["5"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_4"]=value;
	Form_Data_onChange("5","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_4",value,Temp_Data);
 	//handleLastDataPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
    setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
	//handleAddPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data,App_Data['POSTAUCT_REDEMPTION_PERIOD_REVIEW']);
  }; 
  

    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
	Temp_Data["5"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_5"]=value;
	//handleAddPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data,App_Data['POSTAUCT_REDEMPTION_PERIOD_REVIEW']);
	Form_Data_onChange("5","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_5",value,Temp_Data);
 	//handleLastDataPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
    setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
 }; 
  

const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
	Temp_Data["9"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_0"]=value;
	Form_Data_onChange("9","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
    setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
	//handleAddPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data,App_Data['POSTAUCT_REDEMPTION_PERIOD_REVIEW']);
  }; 
  

    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
	Temp_Data["9"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_1"]=value;
	//handleAddPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data,App_Data['POSTAUCT_REDEMPTION_PERIOD_REVIEW']);
	Form_Data_onChange("9","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
    setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
 }; 
  
    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
	Temp_Data["9"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_2"]=value;
	//handleAddPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data,App_Data['POSTAUCT_REDEMPTION_PERIOD_REVIEW']);
	Form_Data_onChange("9","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
    setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
 }; 
  
    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
	Temp_Data["9"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_3"]=value;
	//handleAddPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data,App_Data['POSTAUCT_REDEMPTION_PERIOD_REVIEW']);
	Form_Data_onChange("9","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_3",value,Temp_Data);
 	//handleLastDataPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
    setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
 }; 
  
    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
	Temp_Data["9"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_4"]=value;
	//handleAddPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data,App_Data['POSTAUCT_REDEMPTION_PERIOD_REVIEW']);
	Form_Data_onChange("9","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_4",value,Temp_Data);
 	//handleLastDataPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
    setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!POSTAUCT_REDEMPTION_PERIOD_REVIEW) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedPOSTAUCT_REDEMPTION_PERIOD_REVIEW =JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
  updatedPOSTAUCT_REDEMPTION_PERIOD_REVIEW[Sec] = [...updatedPOSTAUCT_REDEMPTION_PERIOD_REVIEW[Sec], newRow];
  setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(updatedPOSTAUCT_REDEMPTION_PERIOD_REVIEW);
};

const handleDeleteRow = (sec,index) => {
  const updatedPOSTAUCT_REDEMPTION_PERIOD_REVIEW = JSON.parse(JSON.stringify(POSTAUCT_REDEMPTION_PERIOD_REVIEW));
  updatedPOSTAUCT_REDEMPTION_PERIOD_REVIEW[sec].splice(index, 1);
  setPOSTAUCT_REDEMPTION_PERIOD_REVIEW(updatedPOSTAUCT_REDEMPTION_PERIOD_REVIEW);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Post-Auction Redemption Period Review`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Post-Auction Redemption Review ID`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`POSTAUCT Redemption Review ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_0" type="text" className="form-control" placeholder="POSTAUCT Redemption Review ID" value={POSTAUCT_REDEMPTION_PERIOD_REVIEW["1"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_0`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter POSTAUCT Redemption Review ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_1" type="text" className="form-control" placeholder="Asset ID" value={POSTAUCT_REDEMPTION_PERIOD_REVIEW["1"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_1`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_2" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Redemption Period Applies`)} <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_2" type="checkbox" style={{ marginLeft: '5px' }}  onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_2_Change} 
					  checked={POSTAUCT_REDEMPTION_PERIOD_REVIEW?.["1"]?.["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_2"] === "true" || POSTAUCT_REDEMPTION_PERIOD_REVIEW?.["1"]?.["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_2"] === true} />
					</label>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Redemption Period Risk`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_3"  value={POSTAUCT_REDEMPTION_PERIOD_REVIEW["1"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_3`]} onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_1_3_Change} className="form-control" name="Redemption Period Risk"  >
						  <option value="None">None</option>
						  <option value="Low">Low</option>
						  <option value="Medium">Medium</option>
						  <option value="High">High</option>
						  <option value="Critical">Critical</option>
						  <option value="Unknown">Unknown</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Redemption Period Risk
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Redemption Start Date`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_SECTION" className="row">
			                {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Redemption Start Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_0" type="date"  value={POSTAUCT_REDEMPTION_PERIOD_REVIEW["2"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_0`]} 
							onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_0_Change} style={{ borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_0"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Redemption Start Date
					  </div>
				  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Redemption End Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_1" type="date"  value={POSTAUCT_REDEMPTION_PERIOD_REVIEW["2"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_1`]} 
							onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_1_Change} style={{ borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_1"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Redemption End Date
					  </div>
				  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Redemption Amount USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_2" type="text" className="form-control" placeholder="Redemption Amount USD" value={POSTAUCT_REDEMPTION_PERIOD_REVIEW["2"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_2`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Redemption Amount USD`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Legal Counsel Review Status`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_3_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Legal Counsel Review Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_3_0"  value={POSTAUCT_REDEMPTION_PERIOD_REVIEW["3"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_3_0`]} onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_3_0_Change} className="form-control" name="Legal Counsel Review Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="In Review">In Review</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Needs Revision">Needs Revision</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Legal Counsel Review Status
				     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_3_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Investor Disclosure Required`)} <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_3_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_3_1_Change} 
					  checked={POSTAUCT_REDEMPTION_PERIOD_REVIEW?.["3"]?.["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_3_1"] === "true" || POSTAUCT_REDEMPTION_PERIOD_REVIEW?.["3"]?.["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_3_1"] === true} />
					</label>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Review Document Link`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_4_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Review Document Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_4_0" type="text" className="form-control" placeholder="Review Document Link" value={POSTAUCT_REDEMPTION_PERIOD_REVIEW["4"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_4_0`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Review Document Link`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Redemption Review Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_4_1"  value={POSTAUCT_REDEMPTION_PERIOD_REVIEW["4"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_4_1`]} onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_4_1_Change} className="form-control" name="Redemption Review Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="In Review">In Review</option>
						  <option value="Cleared">Cleared</option>
						  <option value="Waiting Period">Waiting Period</option>
						  <option value="Issue Found">Issue Found</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Redemption Review Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Submitted By`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_0" type="text" className="form-control" placeholder="Submitted By" value={POSTAUCT_REDEMPTION_PERIOD_REVIEW["5"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_0`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_1" type="text" className="form-control" placeholder="Submitted At" value={POSTAUCT_REDEMPTION_PERIOD_REVIEW["5"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_1`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_2" type="text" className="form-control" placeholder="Reviewed By" value={POSTAUCT_REDEMPTION_PERIOD_REVIEW["5"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_2`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_3" type="text" className="form-control" placeholder="Reviewed At" value={POSTAUCT_REDEMPTION_PERIOD_REVIEW["5"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_3`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_4"  value={POSTAUCT_REDEMPTION_PERIOD_REVIEW["5"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_4`]} onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_5" type="text" className="form-control" placeholder="Approval Notes" value={POSTAUCT_REDEMPTION_PERIOD_REVIEW["5"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_5`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_5_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_5_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_0"  value={POSTAUCT_REDEMPTION_PERIOD_REVIEW["9"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_0`]} onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_1" type="text" className="form-control" placeholder="Created By" value={POSTAUCT_REDEMPTION_PERIOD_REVIEW["9"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_1`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_2" type="text" className="form-control" placeholder="Created At" value={POSTAUCT_REDEMPTION_PERIOD_REVIEW["9"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_2`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_3" type="text" className="form-control" placeholder="Updated By" value={POSTAUCT_REDEMPTION_PERIOD_REVIEW["9"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_3`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_4" type="text" className="form-control" placeholder="Updated At" value={POSTAUCT_REDEMPTION_PERIOD_REVIEW["9"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_4`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_REDEMPTION_PERIOD_REVIEW_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default POSTAUCT_Redemption_Period_Review;  